/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisputeEvidenceItem } from './DisputeEvidenceItem';
import {
    DisputeEvidenceItemFromJSON,
    DisputeEvidenceItemFromJSONTyped,
    DisputeEvidenceItemToJSON,
    DisputeEvidenceItemToJSONTyped,
} from './DisputeEvidenceItem';
import type { DisputeReason } from './DisputeReason';
import {
    DisputeReasonFromJSON,
    DisputeReasonFromJSONTyped,
    DisputeReasonToJSON,
    DisputeReasonToJSONTyped,
} from './DisputeReason';

/**
 * 
 * @export
 * @interface DisputeMatchBody
 */
export interface DisputeMatchBody {
    /**
     * 
     * @type {DisputeReason}
     * @memberof DisputeMatchBody
     */
    reason: DisputeReason;
    /**
     * 
     * @type {string}
     * @memberof DisputeMatchBody
     */
    description: string;
    /**
     * 
     * @type {Array<DisputeEvidenceItem>}
     * @memberof DisputeMatchBody
     */
    evidence?: Array<DisputeEvidenceItem>;
}



/**
 * Check if a given object implements the DisputeMatchBody interface.
 */
export function instanceOfDisputeMatchBody(value: object): value is DisputeMatchBody {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function DisputeMatchBodyFromJSON(json: any): DisputeMatchBody {
    return DisputeMatchBodyFromJSONTyped(json, false);
}

export function DisputeMatchBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeMatchBody {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': DisputeReasonFromJSON(json['reason']),
        'description': json['description'],
        'evidence': json['evidence'] == null ? undefined : ((json['evidence'] as Array<any>).map(DisputeEvidenceItemFromJSON)),
    };
}

export function DisputeMatchBodyToJSON(json: any): DisputeMatchBody {
    return DisputeMatchBodyToJSONTyped(json, false);
}

export function DisputeMatchBodyToJSONTyped(value?: DisputeMatchBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': DisputeReasonToJSON(value['reason']),
        'description': value['description'],
        'evidence': value['evidence'] == null ? undefined : ((value['evidence'] as Array<any>).map(DisputeEvidenceItemToJSON)),
    };
}

